
class ByteUtils {

    public static formatBytes(bytes: number): string {
        if (bytes < 1024 * 1024) {
            return (bytes / 1024).toFixed(2) + " KB";
        } else if (bytes < 1024 * 1024 * 1024) {
            return (bytes / (1024 * 1024)).toFixed(2) + " MB";
        } else if (bytes < 1024 * 1024 * 1024 * 1024) {
            return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
        }
    }

    public static bytesToGB(bytes: number): number {
        return bytes / (1024 * 1024 * 1024);
    }

    public static bytesToHex(bytes: number[]): string {
        let str = bytes.map(e=> ByteUtils.byteToHex(e)).join(' ');
        return str;
    }

    public static byteToHex(value: number): string {
        value = value & 0xFF;
        let str = value.toString(16);
        if (str.length < 2) {
            str = '0' + str;
        }
        return str.toUpperCase();
    }
}


export default ByteUtils;